import { createResource } from '../../core/api/resource'
import type {
  Asset,
  Cargo,
  Categoria,
  Cliente,
  ConjuntoCaminhao,
  ConjuntoMaquinario, ConjuntoUtilitario,
  Contract,
  ContractColheita,
  ContractMaquinario,
  Dupla,
  Feriado,
  Fleet,
  OutroServicoTransporte,
  Personnel,
  Place,
  Status,
  TransporteMaquina,
  Usuario,
} from '../../core/api/types'

// Núcleo
export const customersResource = createResource<Cliente>('customers', '/customers')
export const usersResource = createResource<Usuario>('users', '/users')

// Cadastros unificados (modelo em inglês)
export const assetsResource = createResource<Asset>('assets', '/assets')
export const placesResource = createResource<Place>('places', '/places')
export const fleetResource = createResource<Fleet>('fleet', '/fleet')
export const personnelResource = createResource<Personnel>('personnel', '/personnel')

// Operacional
export const contractsResource = createResource<Contract>('contracts', '/contracts')

// Os mesmos três sem o recorte de dupla, para as telas fora da Frente de Trabalho e
// do Painel de Descarga (Samuel, 15/10/2026: "essa dupla só vai interferir na frente
// de trabalho e painel de descarga, o resto do HUB todos conseguem ver tudo"). Os de
// cima seguem com o recorte, e são os que a Frente usa.
const TODAS_AS_DUPLAS = { todas_duplas: 1 }
export const fleetTodasDuplasResource = createResource<Fleet>('fleet', '/fleet', TODAS_AS_DUPLAS)
export const personnelTodasDuplasResource = createResource<Personnel>('personnel', '/personnel', TODAS_AS_DUPLAS)
export const contractsTodasDuplasResource = createResource<Contract>('contracts', '/contracts', TODAS_AS_DUPLAS)

// Conjuntos (novo subgrupo)
export const duplasResource = createResource<Dupla>('duplas', '/duplas')
export const conjuntosCaminhaoResource = createResource<ConjuntoCaminhao>('conjuntos-caminhao', '/conjuntos-caminhao')
export const conjuntosMaquinarioResource = createResource<ConjuntoMaquinario>('conjuntos-maquinario', '/conjuntos-maquinario')
export const conjuntosUtilitarioResource = createResource<ConjuntoUtilitario>('conjuntos-utilitario', '/conjuntos-utilitario')
// Maquinário por contrato/frente (segunda tabela da Frente de Trabalho).
export const contractMaquinarioResource = createResource<ContractMaquinario>('contract-maquinario', '/contract-maquinario')
export const contractColheitaResource = createResource<ContractColheita>('contract-colheita', '/contract-colheita')
// Transporte de máquina (log de viagens; entidade dedicada).
export const transporteMaquinaResource = createResource<TransporteMaquina>('transporte-maquina', '/transporte-maquina')
export const outrosServicosTransporteResource = createResource<OutroServicoTransporte>(
  'outros-servicos-transporte', '/outros-servicos-transporte',
)

// Categorias (lookup por FK — usadas nos selects dos formulários)
export const fleetCategoriesResource = createResource<Categoria>('fleet-categories', '/fleet-categories')
export const personnelCategoriesResource = createResource<Categoria>('personnel-categories', '/personnel-categories')
export const placeCategoriesResource = createResource<Categoria>('place-categories', '/place-categories')
export const assetCategoriesResource = createResource<Categoria>('asset-categories', '/asset-categories')
export const modalityCategoriesResource = createResource<Categoria>('modality-categories', '/modality-categories')

// Calendário de feriados. Alimenta a régua de hora extra do Painel de Jornada:
// gravar ou apagar uma data recalcula as horas 50% e 100% daquele dia, inclusive
// em jornada já fechada.
export const feriadosResource = createResource<Feriado>('feriados', '/feriados')

// Cargos da equipe (15/10/2026): o operador com cargo herda as permissões dele.
export const cargosResource = createResource<Cargo>('cargos', '/cargos')

// Status universal (context + code)
export const statusResource = createResource<Status>('status', '/status')
